import { memo } from 'react'
import PropTypes from 'prop-types'
import { Grid, Button } from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'
import ColumnIcon from '@mui/icons-material/ViewColumn'
import Search from './search'

const SearchBar = ({
  className,
  searchKey,
  onSearch,
  onShowFilters,
  onToggleShowColumns,
  ...rest
}) => {
  return (
    <Grid
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        height: '42px',
        padding: '24px 16px 0px 24px'
      }}
      {...rest}
      container
      spacing={3}>

      <Grid item md={6}>
        <Search
          sx={{
            flexGrow: 1,
            maxWidth: 480,
            flexBasis: 480
          }}
          searchKey={searchKey}
          onSearch={onSearch}/>
      </Grid>

      <Grid item>
        {!!onToggleShowColumns && (
          <Button
            sx={{
              margin: '0 10px 0 0',
              '@media (min-width:960px)': {
                margin: '0 0 0 10px',
              },
            }}
            color="primary"
            onClick={onToggleShowColumns}
            size="small"
            variant="outlined">
            <ColumnIcon
              sx={{
                marginRight: 1
              }}/> Show columns
          </Button>
        )}
        {!!onShowFilters && (
          <Button
            sx={{
              margin: '0 10px 0 0',
              '@media (min-width:960px)': {
                margin: '0 0 0 10px',
              },
            }}
            color="primary"
            onClick={onShowFilters}
            size="small"
            variant="outlined">
            <FilterListIcon
              sx={{
                marginRight: 1
              }}/> Show filters
          </Button>
        )}
      </Grid>
    </Grid>
  )
}

SearchBar.propTypes = {
  className: PropTypes.string,
  searchKey: PropTypes.string,
  onSearch: PropTypes.func,
  onShowFilters: PropTypes.func,
  onToggleShowColumns: PropTypes.func,
}

export default memo(SearchBar)
